import React from "react";
import {useHistory, useLocation, useParams} from "react-router-dom";
import PropTypes from "prop-types";
import get from "lodash/get";
import includes from "lodash/includes";
import Image from "components/common/Image";
import styles from "./GenericGameCard/GenericGameCard.scss";
import DynamicLegalWording from "./LegalWording/DynamicLegalWording";

export default function HistoricGameCard(props) {
	const {
		game = {},
	} = props;
	const history = useHistory();
	const { pathname } = useLocation();
	const params = useParams();
	const clinicId = Number(params?.clinicId) || null;
	const nodeId = Number(params?.nodeId) || null;
	const isAdmin = clinicId && includes(pathname, "/admin");
    const isProvider = nodeId && includes(pathname, "/provider");
    const bannerImageAltText = get(game, "greenlineGameTemplateSettings.cardSettings.bannerImageAltText");
    const bannerImage = get(game, "greenlineGameTemplateSettings.cardSettings.bannerImage");
    const gameOverImage = get(game, "greenlineGameTemplateSettings.cardSettings.gameOverImage");
    const legalWordingFilePath = get(game, "greenlineGameTemplateSettings.cardLegalWordingFile");

	const handleDashboardClick = () => {
        if (isAdmin) {
            history.push(`/admin/clinic/${clinicId}/games/${game.greenlineGameId}`);
        } else if(isProvider) {
            history.push(`/provider/location/${nodeId}/clinic/${clinicId}/games/${game.greenlineGameId}`);
        } else {
            history.push(`/games/${game.greenlineGameId}`);
        }
    }

    return (
	    <div className={styles.root}>
		    <div className={styles.gameContainer}>
			    <div className={styles.banner}>
				    <Image
						alt={bannerImageAltText}
						className="full-width"
						src={bannerImage}
					/>
			    </div>
			    <div className={styles.animation}>
					<Image
						className="full-width"
						src={gameOverImage}
					/>
			    </div>
			    <div className={styles.gameDetails}>
				    <div className={styles.dates}>
					    {game.startDate} - {game.endDate}
				    </div>
				    {!!legalWordingFilePath ? (
					    <DynamicLegalWording filePath={legalWordingFilePath}/>
				    ) : null}
				    <div className={styles.viewLeaderboardLink} onClick={handleDashboardClick}>
					    View the Leaderboard <i className={"fa-solid fa-chevron-right"}/>
				    </div>
			    </div>
		    </div>
	    </div>
	);
}

HistoricGameCard.propTypes = {
	game: PropTypes.object,
};